<template>
  <a-modal
    v-model="visible"
    :title="
      `${formType === 'add' ? $t('com_sider_menu_role_add') : $t('com_sider_menu_role_edit')} `
    "
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    @ok="
      () => {
        formType === 'add' ? addSubmit() : editSubmit();
      }
    "
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    centered
  >
    <a-form-model :model="form" :rules="formRules" ref="formElement">
      <!-- 名称 -->
      <a-form-model-item :label="$t('role_form_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('role_form_name_placeholder')"
          allowClear
          @input="formInput"
          ref="addFormName"
        />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_description')" prop="description" style="margin:0">
        <a-textarea
          v-model="form.description"
          :placeholder="$t('com_form_description_placeholder')"
          :rows="6"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/role';

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // 新增
      visible: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('role_form_name_placeholder'),
            trigger: 'change',
          },
        ],
      },
      // 搜索
      form: {
        name: undefined,
        description: undefined,
      },
      formError: '',
      formType: '',
      formLoading: false,
    };
  },
  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback();
    },

    // Role - 显示
    show() {
      this.visible = true;
      this.formType = 'add';

      // focus name
      this.$nextTick(() => {
        this.$refs.addFormName && this.$refs.addFormName.focus();
        this.formReset();
      });
    },
    // Role - 提交
    addSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;
          API.RoleAdd(this.form)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_add_success'));
                this.visible = false;
                this.formReset();
                // 更新列表
                this.updateList();
              } else {
                this.formError = res.message;
              }
            })
            .finally(() => {
              this.formLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // Role - error reset
    formInput() {
      this.formError = '';
    },
    // Role - add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      this.form = {
        name: undefined,
        description: undefined,
      };
    },

    // edit
    editRole(record) {
      this.visible = true;
      this.formType = 'edit';
      // focus name
      this.$nextTick(() => {
        this.$refs.addFormName && this.$refs.addFormName.focus();
      });
      this.form = { ...record };
    },

    // Role - 提交
    editSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;
          API.RoleEdit(this.form)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_edit_success'));
                this.visible = false;
                this.formReset();
                // 更新列表
                this.updateList();
              } else {
                this.formError = res.message;
              }
            })
            .finally(() => {
              this.formLoading = false;
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
